import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { verifyPhoneNumber } from '../functions'

function useVerifyPhoneNumber() {
  const toast = useToast()
  return useMutation(verifyPhoneNumber, {
    onSuccess(data) {
      const { error } = data.data
      if (error)
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: error,
          hideAfter: 3000,
        })
    },
    onError(error) {
      // TODO: Currently, a Sentry log is removed from here because Sentry is not imported in Web.
      // Need to create a Sentry class to dynamically handle import for App and Web.
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
export { useVerifyPhoneNumber }
